import { useEffect, useRef, useState } from 'react';
import TextField from '@app/components/Layout/Shares/FormHelpers/TextField';
import TextAreaField from '@app/components/Layout/Shares/FormHelpers/TextAreaField';
import DatePickerField from '@app/components/Layout/Shares/FormHelpers/DatimePickerField';
import PriceFieldV2 from '@app/components/Layout/Shares/FormHelpers/PriceField_V2';
import FKMealServiceSelect from '@app/components/Shares/Select/FoodKid/MealServiceSelect/Dynamic';
import {
    PAYMENT_VOUCHER_TYPE,
    RECEIPT_VOUCHER_TYPE,
} from '@app/constants/receiptCost.CONST';
import { MOMENT_RANGE_TYPE } from '@app/constants/datetime.const';
import RangeDateFieldV2 from '@app/components/Shares/Date/RangeDate/RangeDateFieldV2';
import DynamicCostSelectField from '@app/components/Shares/Select/Income/CostList/DynamicField';
import PaymentTypeSelectField from '@app/components/Shares/Select/Income/PaymentTypeSelect/DynamicField';
import DynamicAccountBankSelectField from '@app/components/Shares/Select/Income/AccountBank/DynamicField';
import _ from 'lodash';
import _paymntVoucherHelpers from './paymntVouPage.helpers';
import PaymentVoucherTypeSelectField from '@app/components/Shares/Select/Income/PaymentVoucherTypeSelect/DynamicField';
import alertUtils from '@app/utils/alert';
import { formatDateUnix } from '@app/utils/datetime.utils';
import {
    ScModalFinalForm,
    ScField,
    finalFormMutators,
} from '@app/components/Base/ScFinalForm';

const PaymentVoucherAddOrEditPopup = ({
    isShow,
    onClose,
    onSubmit,
    initialValues,
    oId,
}) => {
    const [paymntVouType, setPaymntVouType] = useState(-1);
    const [dateRange, setDateRange] = useState({});
    const [serviceId, setServiceId] = useState(-1);
    const [maxDateTo, setMaxDateTo] = useState(0);

    /** Ref giữ form API để gọi mutators từ useEffect */
    const formRef = useRef(null);

    const onSetTotal = async () => {
        if (paymntVouType && !_.isEmpty(dateRange)) {
            const iTotal = await _paymntVoucherHelpers.getTotalByDate(
                oId,
                dateRange,
                paymntVouType,
                serviceId,
            );

            formRef.current?.mutators?.setValue('i_total', iTotal);
        }
    };

    useEffect(() => {
        onSetTotal();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dateRange, paymntVouType, serviceId]);

    useEffect(() => {
        if (!serviceId) return;
        _paymntVoucherHelpers.getMaxDateTo(oId, paymntVouType).then((res) => {
            setMaxDateTo(res);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paymntVouType]);

    const onPaymentVoucherTypeChange = (s) => {
        setPaymntVouType(s);
    };

    const onDateRangeChange = (s) => {
        setDateRange(s);
    };

    const onServiceChange = (s) => {
        setServiceId(s);
    };

    const handleSubmitForm = (dataSave) => {
        if (maxDateTo > 0) {
            const { startDate, endDate } = dataSave.i_daterange_dt;
            const i_datefrom = startDate.unix();
            const i_dateto = endDate.unix();
            const strDate = formatDateUnix(maxDateTo);
            if (i_datefrom <= maxDateTo) {
                alertUtils.showWarning(
                    ` Từ ngày tính tiền không thể nhỏ hơn ngày ${strDate}`,
                );
                return;
            }
            if (i_dateto <= maxDateTo) {
                alertUtils.showWarning(
                    ` Đến ngày tính tiền không thể nhỏ hơn ngày ${strDate}`,
                );
                return;
            }
        }

        if (onSubmit) {
            onSubmit(dataSave);
        }
    };

    //
    return (
        <ScModalFinalForm
            open={isShow}
            onClose={onClose}
            title={`Thông tin phiếu chi (${initialValues?.i_code})`}
            onSubmit={handleSubmitForm}
            className="full-size"
            mutators={finalFormMutators}
        >
            {({ form }) => {
                formRef.current = form;
                return (
                    <>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <ScField
                                        name="i_datefound_dt"
                                        className="form-control"
                                        label="Ngày lập"
                                        component={DatePickerField}
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <ScField
                                    name="i_paymentvouchertype"
                                    className="form-control"
                                    label="Loại phiếu chi"
                                    component={PaymentVoucherTypeSelectField}
                                    onChange={onPaymentVoucherTypeChange}
                                />
                            </div>
                            <div className="col-md-4">
                                <FKMealServiceSelect
                                    label="Tiền dịch vụ"
                                    oId={oId}
                                    isNull={
                                        paymntVouType !==
                                        PAYMENT_VOUCHER_TYPE.SERVICE
                                    }
                                    onChange={onServiceChange}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-8">
                                <ScField
                                    name="i_daterange_dt"
                                    className="form-control"
                                    component={RangeDateFieldV2}
                                    showType="form"
                                    rangeType={MOMENT_RANGE_TYPE.DAY}
                                    onChange={onDateRangeChange}
                                    minDate={+maxDateTo}
                                />
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <ScField
                                        name="i_total"
                                        className="form-control"
                                        label="Số tiền"
                                        component={PriceFieldV2}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <ScField
                                        name="cl_id"
                                        className="form-control"
                                        label="Loại khoản chi"
                                        component={DynamicCostSelectField}
                                        oId={oId}
                                        type={RECEIPT_VOUCHER_TYPE.PHIEU_CHI}
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <ScField
                                        name="cl_source"
                                        className="form-control"
                                        label="Trích từ khoản"
                                        component={DynamicCostSelectField}
                                        oId={oId}
                                        type={RECEIPT_VOUCHER_TYPE.PHIEU_THU}
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <ScField
                                        name="i_referencecode"
                                        className="form-control"
                                        label="Số chứng từ"
                                        component={TextField}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <ScField
                                        name="i_paymenttype"
                                        className="form-control"
                                        label="Hình thức thanh toán"
                                        component={PaymentTypeSelectField}
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <ScField
                                        name="ab_id"
                                        className="form-control"
                                        label="Chi từ tài khoản"
                                        component={
                                            DynamicAccountBankSelectField
                                        }
                                        oId={oId}
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <ScField
                                        name="i_receivername"
                                        className="form-control"
                                        label="Người nhận tiền"
                                        component={TextField}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <ScField
                                        name="i_address"
                                        className="form-control"
                                        label="Địa chỉ"
                                        component={TextField}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <ScField
                                        name="i_description"
                                        className="form-control"
                                        label="Nội dung chi tiền"
                                        rows={3}
                                        component={TextAreaField}
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                );
            }}
        </ScModalFinalForm>
    );
};

export default PaymentVoucherAddOrEditPopup;
